// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2nPqI","list":"BalanceDue_list__3D0Pn","listRow":"BalanceDue_listRow__2ThzR","total":"BalanceDue_total__30Qyh"};